import { Store, Module, ActionContext } from "vuex";
import ListModule from "./list-module";
import ListState from "./list-state";
import PackingModel from "../entities/packingModel";
import Ajax from "../../lib/ajax";
interface PackingState extends ListState<PackingModel> {
  item: PackingModel;
}
class PackingModule extends ListModule<PackingState, any, PackingModel> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<PackingModel>(),
    loading: false,
    item: {}
  };
  actions = {
    async check(context: ActionContext<PackingState, any>) {
      context.state.loading = true;
      const {
        data: { result, success }
      } = await Ajax.get("/api/services/app/Packing/Check");

      context.state.item = result as PackingModel;
      context.state.loading = false;
    },
    async init(context: ActionContext<PackingState, any>, payload: any) {
      const {
        data: { result, success }
      } = await Ajax.put("/api/services/app/Packing/Init", payload.data);
      context.state.item = result as PackingModel;
    },
    async checkItem(context: ActionContext<PackingState, any>, payload: any) {
      context.state.loading = true;
      const {
        data: { result, success }
      } = await Ajax.get("/api/services/app/Packing/CheckItem", {
        params: payload.data
      });

      context.state.loading = false;
      return result;
    },
    async pushItem(context: ActionContext<PackingState, any>, payload: any) {
      const {
        data: { result, success }
      } = await Ajax.put("/api/services/app/Packing/PushItem", payload.data);
      if (result.inputSerial) {
        return result;
      } else {
        context.state.item = result as PackingModel;
        return null;
      }
    },
    async createGroup(context: ActionContext<PackingState, any>) {
      const {
        data: { result, success }
      } = await Ajax.put("/api/services/app/Packing/CreateGroup");
      context.state.item = result as PackingModel;
    },
    async revertGroup(context: ActionContext<PackingState, any>) {
      const {
        data: { result, success }
      } = await Ajax.put("/api/services/app/Packing/RevertGroup");
      context.state.item = result as PackingModel;
    },
    async end(context: ActionContext<PackingState, any>) {
      const {
        data: { result, success }
      } = await Ajax.put("/api/services/app/Packing/End");
      context.state.item = result as PackingModel;
    },
    async missingItems(context: ActionContext<PackingState, any>) {
      const {
        data: { result, success }
      } = await Ajax.put("/api/services/app/Packing/MissingItems");
      context.state.item = result as PackingModel;
    },
    async fastPackItems(context: ActionContext<PackingState, any>) {
      const {
        data: { result, success }
      } = await Ajax.put("/api/services/app/Packing/FastPackItems");
      context.state.item = result as PackingModel;
    },
  };

  mutations = {
    setCurrentPage(state: PackingState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: PackingState, pagesize: number) {
      state.pageSize = pagesize;
    }
  };
}
const packingModule = new PackingModule();
export default packingModule;
